import React, { ReactNode } from "react";
import { Page,Navbar, NavLeft, NavRight, NavTitle} from "framework7-react";
import { useAuth } from "../auth/AuthProvider";
import {useTranslation} from "react-i18next";
import './MainLayout.css';
import {MainToolBar} from "./MainToolBar";
import {getStoragedCurrentOperator} from "../auth/authHelper";

interface MainLayoutProps {
    children: ReactNode;
}
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const storedOperatorValue = getStoragedCurrentOperator();
    if (!auth || typeof auth.logout !== "function") {
        return <div>{t('notifications.loading')}</div>;
    }

    return (
        <Page className="main-layout">
            <Navbar style={{ height: "60px" }}>
                <NavLeft />
                <NavTitle>
                    <img
                        src={toAbsoluteUrl(`/img/operator_logo/logo_${storedOperatorValue}.webp`)}
                        onError={(e) => {
                            e.currentTarget.src = toAbsoluteUrl(`/img/operator_logo/betstack_logo.png`);
                        }}
                        alt="Logo"
                        style={{ height: "30px" }}
                    />
                </NavTitle>
                <NavRight />
            </Navbar>
            <MainToolBar />
            {children}
        </Page>
    );
};

export default MainLayout;
